export default "__VITE_ASSET__DL4yP$2a__ 100w";